import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OcSearchParamType} from "../interface";
import {updateExchangeRate} from "../../../../../api/main/OcApi";

export const useUpdateExchangeRate = ({closeCallback}: { closeCallback: () => any }) => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OcSearchParamType & {
            overseasReqList: { overseasId: number }[]
        }) => updateExchangeRate(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "적용되었습니다.",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readOverseas"]})
                    closeCallback()
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
